import { UrlParams } from '../models/url-params';

type ResolvedUrlParams = Required<UrlParams>;

export function getUrlParams(): ResolvedUrlParams {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  return {
    token: queryParams.get('token') ?? '',
    instance: queryParams.get('instance') ?? '',
    language: queryParams.get('language') ?? '',
    gameId: queryParams.get('gameId') ?? '',
  };
}
